<template>
  <header class="site-header matrix-surface">
    <div class="container header-inner">
      <router-link to="/" class="brand" aria-label="The Nakamotos Club home"><img src="/img/naka-logo.png" alt="The Nakamotos Club" class="pixelated" /></router-link>
      <nav aria-label="Main navigation">
        <router-link to="/collection">300 Club</router-link>
        <router-link to="/market">Market</router-link>
        <router-link :to="{ path: '/', hash: '#rarepepe' }">CryptoArt history</router-link>
        <details class="explore-menu" ref="menu">
          <summary>Explore <span aria-hidden="true">⌄</span></summary>
          <div class="menu-items" @click="closeMenu">
            <router-link :to="{ path: '/', hash: '#search' }">Find a Naka</router-link>
            <router-link :to="{ path: '/', hash: '#provenance' }">Every card is unique</router-link>
            <router-link :to="{ path: '/', hash: '#community' }">Community</router-link>
          </div>
        </details>
      </nav>
      <div class="header-socials">
        <a href="https://twitter.com/TheNakasClub" class="social-link" target="_blank" rel="noopener noreferrer" aria-label="The Nakas Club on X"><img src="@/assets/img/twitter-icon.svg" alt="" /></a>
      </div>
    </div>
  </header>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
const menu = ref(null);
const closeMenu = () => { if (menu.value) menu.value.open = false; };
const outside = event => { if (!menu.value?.contains(event.target) || event.key === 'Escape') closeMenu(); };
onMounted(() => { document.addEventListener('click', outside); document.addEventListener('keydown', outside); });
onUnmounted(() => { document.removeEventListener('click', outside); document.removeEventListener('keydown', outside); });
</script>
<style scoped>
.header-inner { min-height: 166px; display: flex; align-items: center; gap: 42px; }
.brand { margin-right: auto; flex-shrink: 0; padding-block: 20px; }
.brand img { display: block; width: 154px; height: auto; }
nav { display: flex; align-items: center; gap: 34px; }
nav > a, summary { font: 13px/1.5 var(--font-titles); color: var(--ink); text-transform: uppercase; white-space: nowrap; }
nav > a:hover, summary:hover { color: var(--green); }
.header-socials { display: flex; gap: 9px; }
.explore-menu { position: relative; z-index: 20; }
summary { list-style: none; display: flex; gap: 12px; align-items: center; }
summary::-webkit-details-marker { display: none; }
.menu-items { position: absolute; top: 32px; right: 0; width: 224px; padding: 8px 0; background: white; border: 1px solid var(--forest); box-shadow: var(--pixel-shadow); }
.menu-items a { display: block; padding: 13px 18px; font: 11px/1.5 var(--font-titles); color: var(--ink); }
.menu-items a:hover { background: var(--pale); }
@media (max-width: 700px) {
 .header-inner { min-height: 124px; gap: 14px; flex-wrap: wrap; padding-bottom: 18px; }
 .brand { padding-block: 12px 0; } .brand img { width: 115px; }
 .header-socials { margin-left: auto; }
 nav { order: 3; width: 100%; gap: 0; justify-content: space-between; padding-top: 6px; }
 nav > a, summary { font-size: 10px; }
}
</style>
